import React from 'react';
import DigitalOpenHouse from '../../components/DigitalOpenHouse';

function LRLive() {
    return <DigitalOpenHouse />;
}

export default LRLive;
